


const countriesAccept = [
    'India',
    'United Kingdom',
    'United States',
    'Japan',
    "Germany",
    'European Union',
    'Canada',
]


export default countriesAccept